import Oidc from 'oidc-client'

function getOicdManager() {
  return new Oidc.UserManager({
    userStore: new Oidc.WebStorageStateStore(),
    authority: window.runtimeConfig.idServerAuthority,
    redirect_uri: window.runtimeConfig.idServerRedirectUri,
    post_logout_redirect_uri:
      window.runtimeConfig.idServerPostLogoutRedirectUri,
    client_id: window.runtimeConfig.idServerClientId,
    loadUserInfo: true,
    response_type: 'id_token token',
    scope: 'openid adminportal.api.read_only adminportal.api.full_access roles tenant profile'
  })
}
class IdentityHandler {
  constructor() {
    this.user = null
    this.signedIn = null
    this.mgr = getOicdManager()
  }
  isAdmin() {
    return this.mgr.getUser().then(function(user) {
      if (user == null) {
        return false
      } else {
        return user.profile.role.includes('Admin')
      }
    })
  }
  isLoggedIn() {
    return this.mgr.getUser().then(function(user) {
      return user != null
    })
  }
  getAccessToken() {
    let mgr = this.mgr
    return new Promise(function(resolve, reject) {
      mgr.getUser().then(function(user) {
        if (user == null) {
          console.log('getAccessToken: User is null')
          reject({response: new Response(null, {status: 401, statusText: 'Could not find user'})})
        } else {
          resolve(user.access_token)
        }
      })
    })
  }
  getProfile() {
    return this.mgr.getUser().then(function(user) {
      if (user != null) {
        return user.profile
      }
    })
  }
  signIn() {
    this.mgr.signinRedirect().catch(function(err) {
      console.log(err)
    })
  }
  logout() {
    var self = this
    this.mgr
      .signoutRedirect()
      .then(function(resp) {
        self.mgr.signedIn = false
        self.mgr.removeUser()
        console.log('logged out', resp)
      })
      .catch(function(err) {
        console.log(err)
      })
  }
  getUser() {
    let self = this
    this.mgr
      .getUser()
      .then(function(user) {
        if (user == null) {
          self.signIn()
        } else {
          self.storeUser(user)
          self.user = user
          self.signedIn = true
        }
      })
      .catch(function(err) {
        console.log(err)
      })
  }
}

const instance = new IdentityHandler()
Object.freeze(instance)

export default instance



// WEBPACK FOOTER //
// ./src/core/identity-handler.js